import React from 'react';
import { ArrowRight } from 'lucide-react';

interface TokenConverterProps {
  convertAmount: string;
  onConvertAmountChange: (value: string) => void;
  onConvert: () => void;
  loading: boolean;
  tokenToWeiRate: number;
}

export function TokenConverter({ 
  convertAmount, 
  onConvertAmountChange, 
  onConvert, 
  loading,
  tokenToWeiRate 
}: TokenConverterProps) {
  return (
    <div className="bg-gray-800 rounded-lg p-4">
      <h3 className="text-lg font-semibold text-white mb-4">Convert Tokens to WEI</h3>
      <div className="flex gap-4 items-center">
        <div className="flex-1">
          <input
            type="number"
            value={convertAmount}
            onChange={(e) => onConvertAmountChange(e.target.value)}
            placeholder="Amount of tokens"
            className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-white"
            min="0"
          />
        </div>
        <ArrowRight className="text-gray-400" size={20} />
        <div className="flex-1">
          <input
            type="text"
            value={convertAmount ? `${Math.floor(parseInt(convertAmount) / tokenToWeiRate)} WEI` : ''}
            readOnly
            placeholder="WEI amount"
            className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white"
          />
        </div>
        <button
          onClick={onConvert}
          disabled={loading || !convertAmount}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 rounded-lg transition-colors text-white"
        >
          Convert
        </button>
      </div>
    </div>
  );
}